export const NavigationIcon = ({
  icon: Icon,
}: {
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
}) => <Icon className="mr-2 h-5 w-auto text-gray-700" aria-hidden="true" />;
